<template>
    <div class="nf-bar">
        <div class="nf-group">
            <label class="nf-label">{{ $t('news.filters.status') }}</label>
            <select v-model="localStatus" class="nf-select" @change="emitChange">
                <option value="">{{ $t('news.filters.all') }}</option>
                <option value="draft">{{ $t('news.status.draft') }}</option>
                <option value="published">{{ $t('news.status.published') }}</option>
            </select>
        </div>

        <div class="nf-group">
            <label class="nf-label">{{ $t('news.filters.category') }}</label>
            <select v-model="localCategory" class="nf-select" @change="emitChange">
                <option value="">{{ $t('news.filters.all') }}</option>
                <option
                    v-for="cat in categories"
                    :key="cat.id"
                    :value="cat.id"
                >
                    {{ categoryLabel(cat) }}
                </option>
            </select>
        </div>

        <div class="nf-group nf-group--search">
            <label class="nf-label">{{ $t('news.filters.search') }}</label>
            <div class="nf-search">
                <i class="fal fa-search"></i>
                <input
                    v-model="localSearch"
                    type="search"
                    class="nf-search-input"
                    :placeholder="$t('news.filters.search')"
                    @input="onSearchInput"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsFilters',
    props: {
        categories: { type: Array, default: () => [] },
        value: {
            type: Object,
            default: () => ({ status: '', news_category_id: '', search: '' })
        }
    },
    data() {
        return {
            localStatus: this.value.status || '',
            localCategory: this.value.news_category_id || '',
            localSearch: this.value.search || '',
            searchTimer: null
        }
    },
    computed: {
        lang() {
            return this.$store.state.lang
        }
    },
    methods: {
        categoryLabel(cat) {
            if (!cat) return ''
            if (cat.translations && cat.translations.length) {
                const match =
                    cat.translations.find((t) => t.locale === this.lang) ||
                    cat.translations.find((t) => t.locale === 'fr') ||
                    cat.translations[0]
                return match && (match.name || match.title) || cat.name || '—'
            }
            return cat.name || '—'
        },
        emitChange() {
            this.$emit('change', {
                status: this.localStatus,
                news_category_id: this.localCategory,
                search: this.localSearch
            })
        },
        onSearchInput() {
            if (this.searchTimer) clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => this.emitChange(), 350)
        }
    }
}
</script>

<style scoped>
.nf-bar {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: flex-end;
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    padding: 14px 16px;
    margin-bottom: 16px;
}

.nf-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 180px;
}

.nf-group--search {
    flex: 1;
    min-width: 220px;
}

.nf-label {
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v2-text-3);
    margin: 0;
}

.nf-select {
    height: 36px;
    padding: 0 10px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    background: var(--v2-surface-0);
    font-size: 0.8125rem;
    color: var(--v2-text-1);
    cursor: pointer;
    transition: border-color var(--v2-transition-fast);
}

.nf-select:hover {
    border-color: var(--v2-border-strong);
}

.nf-select:focus {
    outline: none;
    border-color: var(--v2-primary);
    box-shadow: var(--v2-shadow-focus);
}

.nf-search {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    background: var(--v2-surface-0);
    transition: border-color var(--v2-transition-fast);
}

.nf-search:focus-within {
    border-color: var(--v2-primary);
    box-shadow: var(--v2-shadow-focus);
}

.nf-search i {
    color: var(--v2-text-4);
    font-size: 0.85rem;
}

.nf-search-input {
    flex: 1;
    border: 0;
    outline: none;
    background: transparent;
    font-size: 0.8125rem;
    color: var(--v2-text-1);
    min-width: 0;
}

.nf-search-input::placeholder {
    color: var(--v2-text-4);
}
</style>
